import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.955 4a5.04 5.04 0 0 1 5 5.065V10.5a7.85 7.85 0 0 1-2.393 5.322 2 2 0 0 0 .982 3.431l2.021.388c4.2 1.013 6.39 2.956 6.39 4.358v4h-24V24c0-1.406 2.21-3.359 6.391-4.359l1.995-.432a2 2 0 0 0 .944-3.415 7.7 7.7 0 0 1-2.33-5.293V9.064a5.037 5.037 0 0 1 5-5.064m0-2a7.03 7.03 0 0 0-7 7.065V10.5a9.7 9.7 0 0 0 2.963 6.754l-1.995.432C5.212 18.813 1.955 21.215 1.955 24v4a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-4c0-2.785-3.257-5.187-7.968-6.313l-2.065-.4a9.8 9.8 0 0 0 3.033-6.787V9.059a7.03 7.03 0 0 0-7-7.059" />
  </svg>
);
const ForwardRef = forwardRef(IconUserOutlineSVG);
ForwardRef.displayName = "IconUserOutline";
export { ForwardRef as IconUserOutline };
